<div *ngIf="pending || error || message" #notice tabindex="-1" class="ia-load-state" [class.ia-load-state--error]="!!error" [attr.role]="error ? 'alert' : 'status'">
  <span *ngIf="pending" class="ia-load-state__spinner" aria-hidden="true"></span>
  <span class="ia-load-state__message">{{ error || (pending ? loadingText : message) }}</span>
  <button *ngIf="error" type="button" class="btn btn-sm btn-secondary" [disabled]="pending || retryDisabled" [attr.aria-label]="retryLabel" (click)="requestRetry()">Try again</button>
</div>
